const config = {
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3001/api",
  cognito: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID || "",
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    region: process.env.REACT_APP_AWS_REGION || "us-east-1",
  },
};

export default config;
